import { Component, OnInit, Input, Self } from '@angular/core';

import { form } from '@leandredev/dcbm-ng-lib';
import { UiForm, UIComponentState, FormControlBase } from '@leandredev/common_ng_14';

@Component({
  selector: 'app-ui-form-parametrecurrency',
  templateUrl: './ParametreCurrency.component.html',
  styleUrls: ['./ParametreCurrency.component.scss'],
  providers: [UIComponentState]
})
export class ParametreCurrencyFormComponent extends UiForm<form.ParametreCurrency> implements OnInit {
  @Input() id = '';

  constructor(@Self() protected uIComponentState: UIComponentState) {
    super(uIComponentState);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.uIComponentState.id = this.id;

    Object.assign(this.state, this.uIComponentState.state);
    Object.assign(this.uIComponentState.state, this.state);

    this.state = this.uIComponentState.state;

    const rootFormGrp = this.formGroup.root;

    if (rootFormGrp.getRawValue().isSealed) this.formGroup.disable();
  }

  public fieldClassHumanName: { [key: string]: string } = {};

  public classChange(value: string, control: FormControlBase): void {
    let oldVal: any;

    oldVal = control.value;

    if (!oldVal) oldVal = {};

    oldVal._class = value;

    control.patchValue(oldVal);
  }
}
